/* Update cart items */
if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0
      );

      this.debouncedOnChange = debounce((event) => {
        if (event.target != document.getElementById('Cart-note')) {
          this.onChange(event);
        }
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      // Initialize free product buttons
      this.initFreeProductButtons();
    }

    // Initialize free product buttons
    initFreeProductButtons() {
      const freeProductButtons = this.querySelectorAll('.promotion button');
      freeProductButtons.forEach((button) => {
        button.addEventListener('click', this.addFreeProduct.bind(this));
      });
    }

    // Add free product to cart
    addFreeProduct(event) {
      event.preventDefault();
      const button = event.currentTarget;

      const variantId = button.dataset.id;
      const quantity = parseInt(button.dataset.quantity || 1);

      if (!variantId) return;

      // Disable button and show loading state
      button.setAttribute('disabled', true);
      button.classList.add('loading');

      // Add item to cart
      const body = JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        ...{ body },
      })
        .then((response) => response.json())
        .then((parsedState) => {
          // Update cart contents
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          // Re-initialize free product buttons
          this.initFreeProductButtons();
        })
        .catch((error) => {
          console.error(error);

          // Re-enable button
          button.removeAttribute('disabled');
          button.classList.remove('loading');
        });
    }

    onChange(event) {
      // Check if we have an altered way of updating several variants in the cart that are linked
      if (event.target.dataset.updateKeys) {
        const lineKeys = event.target.dataset.updateKeys.split(',');

        this.updateVariants(
          lineKeys,
          event.target.dataset.index,
          event.target.value,
          document.activeElement.getAttribute('name')
        );
      } else {
        this.updateQuantity(
          event.target.dataset.index,
          event.target.value,
          document.activeElement.getAttribute('name')
        );
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-item-contents',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-cart-footer-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    updateVariants(lineKeys, line, quantity, name) {
      this.enableLoading(line);

      const updateObject = {};
      lineKeys.forEach((item) => {
        updateObject[item] = quantity;
      });

      const body = JSON.stringify({
        updates: updateObject,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_update_url}.js`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('cart-is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          this.updateLiveRegions(line, parsedState.item_count);
          document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
          this.disableLoading();
          this.runBulkQuantityChange();

          // Re-initialize free product buttons
          this.initFreeProductButtons();

          // Update the product info section
          document.querySelector('product-info')?.checkCartAndInventory();
        })
        .catch((error) => {
          console.error(error);
          document.querySelectorAll('[data-cart-loader-active="show"]').forEach((elem) => {
            elem.classList.add('hidden');
          });
          document.querySelectorAll('[data-cart-loader-active="hidden"]').forEach((elem) => {
            elem.classList.remove('hidden');
          });
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }

    updateQuantity(line, quantity, name) {
      this.enableLoading(line);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('cart-is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          this.updateLiveRegions(line, parsedState.item_count);
          document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
          this.disableLoading();
          this.runBulkQuantityChange();

          // Re-initialize free product buttons
          this.initFreeProductButtons();
        })
        .catch((error) => {
          console.error(error);
          document.querySelectorAll('[data-cart-loader-active="show"]').forEach((elem) => {
            elem.classList.add('hidden');
          });
          document.querySelectorAll('[data-cart-loader-active="hidden"]').forEach((elem) => {
            elem.classList.remove('hidden');
          });
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }

    runBulkQuantityChange() {
      const variantWrapper = document.querySelector('variants-and-buy-buttons');
      if (!variantWrapper) return;

      // Set all quantity selectors in the drawer to 0
      variantWrapper.querySelectorAll('[data-option-quantity]').forEach((variantQuantity) => {
        variantQuantity.value = 0;
      });

      // Now call onBulkQuantityChange after resetting the values
      if (typeof variantWrapper.onBulkQuantityChange === 'function') {
        variantWrapper.querySelectorAll('[data-option-quantity]').forEach((variantQuantity) => {
          variantWrapper.onBulkQuantityChange({
            preventDefault: () => {},
            stopPropagation: () => {},
            stopImmediatePropagation: () => {},
          });
        });
      }
    }

    // show error texts, should not be deleted.
    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        const errorText = document
          .getElementById(`Line-item-error-${line}`)
          .querySelector('.cart-item__error-text');

        if (!errorText) return;

        errorText.innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
      }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document.querySelector('cart-items').classList.add('cart-items-is-loading');
      document.querySelectorAll('[data-cart-loader-active="show"]').forEach((elem) => {
        elem.classList.remove('hidden');
      });
      document.querySelectorAll('[data-cart-loader-active="hidden"]').forEach((elem) => {
        elem.classList.add('hidden');
      });
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      document.querySelector('cart-items').classList.remove('cart-items-is-loading');
    }
  }
  customElements.define('cart-items', CartItems);
}

/* Remove item from the cart  */
if (!customElements.get('cart-remove-button')) {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();

        // Check if we have an altered way of updating several variants in the cart that are linked
        if (this.dataset.updateKeys) {
          const lineKeys = this.dataset.updateKeys.split(',');
          this.closest('cart-items').updateVariants(lineKeys, this.dataset.index, 0, '');
        } else {
          this.closest('cart-items').updateQuantity(this.dataset.index, 0);
        }
      });
    }
  }
  customElements.define('cart-remove-button', CartRemoveButton);
}

/* Update the cart note */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);
}
